import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
// import Login from "../pages/Authentication/Login2"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

import TotalAgentRegistrationsByState from "../pages/TotalAgentRegistration/TotalAgentRegistrationsByState/index"
import TotalAgentRegistrationsByLga from "../pages/TotalAgentRegistration/TotalAgentRegistrationsByLga/index"
import ViewTotalAgentRegistrationsByState from "../pages/TotalAgentRegistration/ViewTotalAgentRegistrationsByState/index"
import ViewTotalAgentRegistrationsByLga from "../pages/TotalAgentRegistration/ViewTotalAgentRegistrationsByLga/index"
// pending agent registrations
import PendingAgentRegistrationsByState from "../pages/PendingAgentRegistration/PendingAgentRegistrationsByState/index"
import PendingAgentRegistrationsByLga from "../pages/PendingAgentRegistration/PendingAgentRegistrationsByLga/index"
import ViewPendingAgentRegistrationsByState from "../pages/PendingAgentRegistration/ViewPendingAgentRegistrationsByState/index"
import ViewPendingAgentRegistrationsByLga from "../pages/PendingAgentRegistration/ViewPendingAgentRegistrationsByLga/index"
// declined agent registrations
import DeclinedAgentRegistrationsByState from "../pages/DeclinedAgentRegistration/DeclinedAgentRegistrationsByState/index"
import DeclinedAgentRegistrationsByLga from "../pages/DeclinedAgentRegistration/DeclinedAgentRegistrationsByLga/index"
import ViewDeclinedAgentRegistrationsByState from "../pages/DeclinedAgentRegistration/ViewDeclinedAgentRegistrationsByState/index"
import ViewDeclinedAgentRegistrationsByLga from "../pages/DeclinedAgentRegistration/ViewDeclinedAgentRegistrationsByLga/index"
// rejected agent registrations
import RejectedAgentRegistrationsByState from "../pages/RejectedAgentRegistration/RejectedAgentRegistrationsByState/index"
import RejectedAgentRegistrationsByLga from "../pages/RejectedAgentRegistration/RejectedAgentRegistrationsByLga/index"
import ViewRejectedAgentRegistrationsByState from "../pages/RejectedAgentRegistration/ViewRejectedAgentRegistrationsByState/index"
import ViewRejectedAgentRegistrations from "../pages/RejectedAgentRegistration/ViewRejectedAgentRegistrations/index"
import ViewRejectedAgentRegistrationsByLga from "../pages/RejectedAgentRegistration/ViewRejectedAgentRegistrationsByLga/index"

import ApprovedAgentRegistrations from "../pages/ApprovedAgentRegistration/ApprovedAgentRegistrations/index"
import ApprovedAgentRegistrationsByLga from "../pages/ApprovedAgentRegistration/ApprovedAgentRegistrationsByLga/index"
import ViewApprovedAgentRegistrationsByState from "../pages/ApprovedAgentRegistration/ViewApprovedAgentRegistrationsByState/index"
import ViewApprovedAgentRegistrationsByLga from "../pages/ApprovedAgentRegistration/ViewApprovedAgentRegistrationsByLga/index"
import ViewApprovedAgentRegistrationsByLga2 from "../pages/ApprovedAgentRegistration/ViewApprovedAgentRegistrationsByLga2/index"
// training records
import TrainingRecordsByState from "../pages/TrainingRecords/TrainingRecordsByState/index"
import TrainingRecordsByLga from "../pages/TrainingRecords/TrainingRecordsByLga/index"
import ViewTrainingRecordsByState from "../pages/TrainingRecords/ViewTrainingRecordsByState/index"
import ViewTrainingRecordsByLga from "../pages/TrainingRecords/ViewTrainingRecordsByLga/index"
// generate code
import GenerateCode from "../pages/GenerateCode/index"
import UserList from "pages/ManageUsers/UserList"
import AgentProfile from "pages/ManageUsers/UserProfile"

import ViewPendingAgentsByLga from "pages/Agents/ViewPendingAgentsByLga"
import ViewTrainingAttendanceByLga from "pages/TrainingAttendance/ViewTrainingAttendanceByLga"
import ForgotPassword from "pages/Authentication/ForgotPassword"
import SearchResult from "pages/SearchResult"

import ThresholdManagement from "pages/ThresholdManagement/index"
import ThresholdManagementByLGA from "pages/ThresholdManagement/lga-threshold"
import RegistrationCounts from "pages/RegistrationCounts"
import FailedAgentRegistration from "pages/FailedAgentRegistration/index"
import NationalTargets from "pages/NationalTargets/index"
import NationalTargetsLga from "pages/NationalTargets/lga-targets"

import AdminApprovedAgentsByState from "pages/ApprovedAgentRegistration/ViewApprovedAgentRegistrationsByState/view-approved-agents-by-state-admin"

import { ROLES } from "constants/roles"
import { MENU_ROUTE_ROLES } from "constants/sidebarMenuConfig"

// Mirror sidebar visibility for route-level access control. Returns the roles
// allowed to reach a given menu path. Drill-down/param routes pass their parent
// menu path. Routes with no `allowedRoles` are open to any authenticated user;
// SUPER_ADMIN bypasses the guard entirely (see routes/route.js).
const access = path => MENU_ROUTE_ROLES[path]

// State Admin / State ALGON Chairman reach these by-LGA drill-down routes via
// the "View LGAs" link on their by-state overview, not via a sidebar entry, so
// they aren't picked up by the sidebar-derived access() above — add them in.
const approvedAgentsByLgaRoles = [
  ...(access("/view-approved-agent-registrations-by-lga") || []),
  ROLES.STATE_ADMIN,
  ROLES.STATE_ALGON_CHAIRMAN,
]

// State Admin reaches this by-LGA threshold view via a redirect from their own
// "Threshold Management" sidebar entry (/threshold-management), not via a
// sidebar entry pointing here directly, so add them in the same way.
const thresholdManagementByLgaRoles = [
  ...(access("/threshold-management-lga") || []),
  ROLES.STATE_ADMIN,
]

// State Admin already reaches /training-records-by-state via their own sidebar
// entry and gets redirected to the by-LGA breakdown from there. LGA Focal
// Person has no sidebar entry pointing at /training-records-by-state at all,
// but is redirected there too (from the same entry point) straight to their
// own LGA's training records — add them in so that brief landing + redirect
// isn't blocked by the route guard.
const trainingRecordsRoles = [
  ...(access("/training-records-by-state") || []),
  ROLES.LGA_FOCAL_PERSON,
]

const authProtectedRoutes = [
  // open to any authenticated user
  { path: "/dashboard", component: <Dashboard /> },
  // total agent registration routes
  {
    path: "/total-agent-registrations-by-state",
    component: <TotalAgentRegistrationsByState />,
    allowedRoles: access("/total-agent-registrations-by-state"),
  },
  {
    path: "/total-agent-registrations-by-lga/:id/:state",
    component: <TotalAgentRegistrationsByLga />,
    allowedRoles: access("/total-agent-registrations-by-state"),
  },
  {
    path: "/view-total-agent-registrations-by-state/:id",
    component: <ViewTotalAgentRegistrationsByState />,
    allowedRoles: access("/total-agent-registrations-by-state"),
  },
  {
    path: "/view-total-agent-registrations-by-lga",
    component: <ViewTotalAgentRegistrationsByLga />,
    allowedRoles: access("/total-agent-registrations-by-state"),
  },
  // approved agent registration routes
  {
    path: "/approved-agents-registration",
    component: <ApprovedAgentRegistrations />,
  },
  {
    path: "/approved-agent-registrations-by-lga/:id/:state",
    component: <ApprovedAgentRegistrationsByLga />,
    allowedRoles: approvedAgentsByLgaRoles,
  },
  {
    path: "/view-approved-agent-registrations-by-state",
    component: <ViewApprovedAgentRegistrationsByState />,
    allowedRoles: access("/view-approved-agent-registrations-by-state"),
  },
  {
    path: "/view-approved-agent-registrations-by-state/:id",
    component: <AdminApprovedAgentsByState />,
    allowedRoles: access("/view-approved-agent-registrations-by-state"),
  },
  {
    path: "/view-approved-agent-registrations-by-lga/:id",
    component: <ViewApprovedAgentRegistrationsByLga2 />,
    allowedRoles: approvedAgentsByLgaRoles,
  },
  {
    path: "/view-approved-agent-registrations-by-lga",
    component: <ViewApprovedAgentRegistrationsByLga />,
    allowedRoles: approvedAgentsByLgaRoles,
  },
  // pending agent registration routes
  {
    path: "/pending-agent-registrations-by-state",
    component: <PendingAgentRegistrationsByState />,
    allowedRoles: access("/view-pending-agent-registrations-by-state"),
  },
  {
    path: "/pending-agent-registrations-by-lga/:id/:state",
    component: <PendingAgentRegistrationsByLga />,
    allowedRoles: access("/view-pending-agent-registrations-by-state"),
  },
  {
    path: "/view-pending-agent-registrations-by-state",
    component: <ViewPendingAgentRegistrationsByState />,
    allowedRoles: access("/view-pending-agent-registrations-by-state"),
  },
  {
    path: "/view-pending-agent-registrations-by-lga",
    component: <ViewPendingAgentRegistrationsByLga />,
  },
  // declined agent registration routes
  {
    path: "/declined-agent-registrations-by-state",
    component: <DeclinedAgentRegistrationsByState />,
    allowedRoles: access("/view-declined-agent-registrations-by-state"),
  },
  {
    path: "/declined-agent-registrations-by-lga/:id/:state",
    component: <DeclinedAgentRegistrationsByLga />,
    allowedRoles: access("/view-declined-agent-registrations-by-state"),
  },
  {
    path: "/view-declined-agent-registrations-by-state",
    component: <ViewDeclinedAgentRegistrationsByState />,
    allowedRoles: access("/view-declined-agent-registrations-by-state"),
  },
  {
    path: "/view-declined-agent-registrations-by-lga",
    component: <ViewDeclinedAgentRegistrationsByLga />,
  },
  {
    path: "/view-rejected-agent-registrations",
    component: <ViewRejectedAgentRegistrations />,
  },
  {
    path: "/view-rejected-agent-registrations-by-state",
    component: <ViewRejectedAgentRegistrationsByState />,
    allowedRoles: access("/view-rejected-agent-registrations-by-state"),
  },
  {
    path: "/view-rejected-agent-registrations-by-lga",
    component: <ViewRejectedAgentRegistrationsByLga />,
  },
  // failed agent registration routes
  {
    path: "/view-failed-agent-registrations",
    component: <FailedAgentRegistration />,
    allowedRoles: access("/view-failed-agent-registrations"),
  },
  // training records routes
  {
    path: "/training-records-by-state",
    component: <TrainingRecordsByState />,
    allowedRoles: trainingRecordsRoles,
  },
  {
    path: "/training-records-by-lga/:id/:state",
    component: <TrainingRecordsByLga />,
    allowedRoles: trainingRecordsRoles,
  },
  {
    path: "/view-training-records-by-state/:id",
    component: <ViewTrainingRecordsByState />,
    allowedRoles: trainingRecordsRoles,
  },
  {
    path: "/view-training-records-by-lga/:id",
    component: <ViewTrainingRecordsByLga />,
    allowedRoles: trainingRecordsRoles,
  },
  // generate code
  {
    path: "/generate-code",
    component: <GenerateCode />,
    allowedRoles: access("/generate-code"),
  },

  {
    path: "/pending-agents-registration",
    component: <ViewPendingAgentsByLga />,
    allowedRoles: access("/pending-agents-registration"),
  },

  {
    path: "/training-attendance",
    component: <ViewTrainingAttendanceByLga />,
    allowedRoles: access("/training-attendance"),
  },

  //threshold management
  {
    path: "/threshold-management",
    component: <ThresholdManagement />,
    allowedRoles: access("/threshold-management"),
  },
  {
    path: "/threshold-management-lga",
    component: <ThresholdManagementByLGA />,
    allowedRoles: thresholdManagementByLgaRoles,
  },

  // registration counts (state -> LGA -> ward)
  {
    path: "/registration-counts",
    component: <RegistrationCounts />,
    allowedRoles: access("/registration-counts"),
  },
  // ponytail: old Payments URL. The header menu is cached in localStorage
  // until re-login, so stale menus still point here. Drop once they've expired.
  { path: "/payments", component: <Navigate to="/registration-counts" replace /> },

  { path: "/search/:param", component: <SearchResult /> },
  { path: "/profile/:npc_id", component: <UserProfile /> },
  {
    path: "/manage-users",
    component: <UserList />,
    allowedRoles: access("/manage-users"),
  },
  { path: "/user-profile", component: <AgentProfile /> },

  // national targets
  {
    path: "/national-targets",
    component: <NationalTargets />,
    allowedRoles: access("/national-targets"),
  },
  {
    path: "/national-targets-lga/:stateId",
    component: <NationalTargetsLga />,
    allowedRoles: access("/national-targets"),
  },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/register", component: <Register /> },
]

export { authProtectedRoutes, publicRoutes }
